import { Box, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import surveyImage from "../../assets/survey image.png";

const CompletedSurveys = () => {
  const [surveys, setSurveys] = useState([]);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    const fetchOngoingSurveys = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/survey/get-survey-by-status?adminsSurveyStatus=COMPLETED`,
        {
          headers: {
            Authorization: `Bearer ${user.accessToken}`,
          },
        }
      );
      const sortedSurveys = res.data.sort(
        (a, b) => new Date(b.updatedDate) - new Date(a.updatedDate)
      );
      setSurveys(sortedSurveys);
      console.log(sortedSurveys)
    };
    fetchOngoingSurveys();
  }, []);
  return (
    <Box px={5} width={"100%"}>
      {surveys.length > 0
        ? surveys.map((survey, i) => (
            <Box
              key={i}
              className="box-option"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#64748B",
                padding: "10px 20px",
                borderRadius: "10px",
                width: "60%",
                my: 1,
              }}
            >
              <Box sx={{ color: "#BEA800" }}>
                <img src={surveyImage} alt="" width={40} />
              </Box>
              <Box pl={2}>
                <Typography sx={{ textAlign: "left" }}>
                  {survey.surveyName}
                </Typography>
                <Box sx={{ display: "flex" }}>
                  <Typography sx={{ textAlign: "left", fontSize: "14px" }}>
                  {new Date(survey.createdDate).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        }
                      )}
                  </Typography>
                  <Typography
                    sx={{
                      textAlign: "left",
                      fontSize: "14px",
                      width: "150px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      ml: 5
                    }}
                  >
                    {survey.uploadLink}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))
        : "No surveys"}
    </Box>
  );
};

export default CompletedSurveys;
